import Head from 'next/head'
import { memo } from 'react'
import shopInfos from 'template/infos'
import Logo from 'template/logos/logo.png'

const shopBaseUrl = shopInfos.url.replace(/\/$/, '')
const logoSrc = typeof Logo === 'string' ? Logo : Logo.src
export const defaultSocialImage = /^https?:\/\//i.test(logoSrc)
  ? logoSrc
  : `${shopBaseUrl}${logoSrc.startsWith('/') ? logoSrc : `/${logoSrc}`}`

// Next Head resolves duplicate keys by registration order. Keep these defaults
// registered before memoized page metadata across unrelated App updates.
const DefaultSeoHead = memo(({ privatePage }: { privatePage: boolean }) => <Head>
  <title>{shopInfos.title}</title>
  <meta name='description' content={shopInfos.description} key='description' />
  <meta property='og:type' content='website' key='og:type' />
  <meta property='og:title' content={shopInfos.title} key='og:title' />
  <meta property='og:description' content={shopInfos.description} key='og:description' />
  <meta property='og:url' content={shopInfos.url} key='og:url' />
  <meta property='og:image' content={defaultSocialImage} key='og:image' />
  <meta property='og:site_name' content={shopInfos.name} key='og:site_name' />
  <meta property='og:locale' content={shopInfos.locale || 'de_DE'} key='og:locale' />
  {privatePage && <meta name='robots' content='noindex, follow' key='robots' />}
  <meta name='twitter:card' content='summary_large_image' key='twitter:card' />
  <meta name='twitter:title' content={shopInfos.title} key='twitter:title' />
  <meta name='twitter:description' content={shopInfos.description} key='twitter:description' />
  <meta name='twitter:image' content={defaultSocialImage} key='twitter:image' />
  <meta name='viewport' content='minimum-scale=1, initial-scale=1, width=device-width, viewport-fit=cover' />
</Head>)
DefaultSeoHead.displayName = 'DefaultSeoHead'

export default DefaultSeoHead
